import * as React from "react"
import { Link } from "gatsby"
import { BannerModuleStyles } from "./BannerModuleStyles"
import { StaticImage } from "gatsby-plugin-image"
import Button from "../Button/Button"

const BannerModule = ({
  children,
  eyebrow,
  title,
  subTitle,
  price,
  ctaText,
  ctaTo,
}) => {
  const handleClickScroll = () => {
    const element = document.getElementById("content-section")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <>
      <BannerModuleStyles>
        {children ? (
          children
        ) : (
          <StaticImage
            className="banner__image"
            imgClassName="banner__image--content"
            src="../../../static/macbook-color.jpg"
            alt="Banner Image"
            layout="fullWidth"
            placeholder="blurred"
          />
        )}

        <div className="container">
          <div className="banner__content">
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && (
              <h1>
                {title}
                <span style={{ color: "var(--color-gold-500)" }}>.</span>
              </h1>
            )}
            {subTitle && <p className="banner__lead">{subTitle}</p>}
            {price && (
              <h2 className="price">
                £{price}
                <span style={{ color: "var(--color-gold-500)" }}>.</span>
              </h2>
            )}
            <div className="banner__btns">
              {ctaText && ctaTo && (
                <Button as={Link} to={ctaTo} text={ctaText} arrow />
              )}
              <Button
                onClick={handleClickScroll}
                text="Learn More"
                arrow
                ghost
              />
            </div>
          </div>
        </div>
        <div className="gradient"></div>
      </BannerModuleStyles>
      <span id="topContent"></span>
    </>
  )
}

export default BannerModule
